module.exports = __webpack_public_path__ + "static/media/caret-square-up.a3f5964e.svg";